/**
 * Mineur ou majeur, d'apres une date de naissance ISO (AAAA-MM-JJ).
 * `null` sans date : on ne conclut pas. L'age est CALCULE, jamais
 * stocke (regle 5 de CLAUDE.md), au jour pres.
 */
export function estMineur(dateNaissance: string | null | undefined): boolean | null {
  if (!dateNaissance) return null;
  const naissance = new Date(`${dateNaissance}T00:00:00`);
  if (Number.isNaN(naissance.getTime())) return null;
  const aujourdhui = new Date();
  let age = aujourdhui.getFullYear() - naissance.getFullYear();
  const anniversairePasse =
    aujourdhui.getMonth() > naissance.getMonth() ||
    (aujourdhui.getMonth() === naissance.getMonth() && aujourdhui.getDate() >= naissance.getDate());
  if (!anniversairePasse) age -= 1;
  return age < 18;
}
